import React from 'react';

// Import styles
import { PaymentWrapper, PaymentIcon } from './styles';

// Import assets
import bluemedia from 'assets/icons/bluemedia.png';
import blik from 'assets/icons/blik.png';
import cards from 'assets/icons/cards.png';

function FooterPayments() {
	return (
		<PaymentWrapper>
			<PaymentIcon src={bluemedia} alt="Bluemedia" />
			<PaymentIcon src={cards} alt="Card payment" />
			<PaymentIcon src={blik} alt="Blik" />
		</PaymentWrapper>
	);
}

export default FooterPayments;
